import { createApi } from '@reduxjs/toolkit/query/react';
import { pensionBaseQuery } from '../../lib/axiosBaseQuery';

export const walletApi = createApi({
  reducerPath: 'walletApi',
  baseQuery: pensionBaseQuery,
  tagTypes: ['Wallet', 'DebitAccounts', 'DDBanks', 'WalletTransactions'],
  endpoints: (builder) => ({
    getDebitAccounts: builder.query<any, void>({
      query: () => ({
        url: `api/v1/Payment/Wallet/accounts`,
        method: 'GET',
      }),
      providesTags: ['DebitAccounts'],
    }),
    getDDBanks: builder.query<any, void>({
      query: () => ({
        url: `api/v1/Payment/Wallet/banks`,
        method: 'GET',
      }),
      providesTags: ['DDBanks'],
    }),
    createDD: builder.mutation<any, Record<string, any>>({
      query: (data) => ({
        url: `api/v1/Payment/Wallet/create-direct-debit`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['DebitAccounts'],
    }),
    getWallet: builder.query<any, void>({
      query: () => ({
        url: `api/v1/Payment/Wallet/get-create`,
        method: 'GET',
      }),
      providesTags: ['Wallet'],
    }),
    selectSchedulePaymentMethod: builder.query<any, { paymentMethod: string; schedule: string[] }>({
      query: ({ paymentMethod, schedule }) => ({
        url: `api/v1/Payment/Wallet/funding`,
        method: 'GET',
        params: { paymentOption: paymentMethod, schedule },
      }),
    }),
    selectUploadPaymentMethod: builder.query<any, { paymentMethod: string; ref: string }>({
      query: ({ paymentMethod, ref }) => ({
        url: `api/v1/Payment/Wallet/funding/upload/${ref}`,
        method: 'GET',
        params: { paymentOption: paymentMethod },
      }),
    }),
    selectMultipleUploadsPaymentMethod: builder.mutation<any, { paymentMethod: string; uploadReferences: string[] }>({
      query: ({ paymentMethod, uploadReferences }) => ({
        url: `api/v1/Payment/Wallet/funding/uploads`,
        method: 'POST',
        data: { paymentOption: paymentMethod, uploadReferences },
      }),
    }),
    getWalletTransactionsHistory: builder.query<any, { startDate: string; endDate: string }>({
      query: ({ startDate, endDate }) => ({
        url: `api/v1/Payment/Wallet/history`,
        method: 'GET',
        params: { StartDate: startDate, EndDate: endDate },
      }),
      transformResponse: (response: any) => {
        if (Array.isArray(response?.data)) {
          return { ...response, data: response.data.reverse() };
        }
        return { ...response, data: [] };
      },
      providesTags: ['WalletTransactions'],
    }),
  }),
});

export const {
  useGetDebitAccountsQuery,
  useGetDDBanksQuery,
  useCreateDDMutation,
  useGetWalletQuery,
  useSelectSchedulePaymentMethodQuery,
  useLazySelectSchedulePaymentMethodQuery,
  useSelectUploadPaymentMethodQuery,
  useLazySelectUploadPaymentMethodQuery,
  useSelectMultipleUploadsPaymentMethodMutation,
  useGetWalletTransactionsHistoryQuery,
} = walletApi;
